import XHR from '@/request/http'
const $h = new XHR()
// url
const url = {
    lists:'/admin/v1/agent/page',
    update:'/admin/v1/agent/update',
    create:'/admin/v1/agent/create',
    del:'/admin/v1/agent/del',
    get_agent:'/admin/v1/agent/get',
}


export async function lists(data)
{
    return $h.request(url.lists,data,'GET')
}

export async function create(data)
{
    return $h.request(url.create,data,'POST')
}

export async function update(data)
{
    return $h.request(url.update,data,'POST')
}

export async function del(data)
{
    return $h.request(url.del,data,'POST')
}

export async function get_agent(data)
{
    return $h.request(url.get_agent,data,'GET')
}